module.exports = "/images/side-tool-settings.svg?a74abb35076f9c17769fe02d0c72d8d4";